import { GDPRSdk, PurposeConfig, MockGDPR , GDPRPromise} from "@ciaopeople/cp-shatsu/GDPR";
import { isDevHost } from "../../lib/utils/DomainNameUtils.js";


const isDev = isDevHost(window.document.location.host);
const alternativeMock = isDev ? new MockGDPR(PurposeConfig.FULL) : undefined;


export function getGDPR(): Promise<GDPRSdk> {
    return GDPRPromise(alternativeMock)
}
